import { render, staticRenderFns } from "./PublishComp.vue?vue&type=template&id=ee67e584&scoped=true"
import script from "./PublishComp.vue?vue&type=script&lang=js"
export * from "./PublishComp.vue?vue&type=script&lang=js"
import style0 from "./PublishComp.vue?vue&type=style&index=0&id=ee67e584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee67e584",
  null
  
)

export default component.exports